import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import React from 'react';
import { ButtonProps, ContentProps } from './index';
import ProductForm from './Form';
import { ClientDataGood } from '../../../Adapter';

export function CreateButton({ remove }: ButtonProps) {
  return (
    <Button
      icon={<DeleteOutlined />}
      type="text"
      onClick={(e) => {
        e.stopPropagation();
        remove();
      }}
    />
  );
}

interface CreateContentProps extends ContentProps {
  item: ClientDataGood;
}

export function CreateContent(props: CreateContentProps) {
  return (
    <ProductForm {...props} />
  );
}

export default {
  CreateButton,
  CreateContent,
};
